import React from 'react';

import { StatusIndicator } from 'shared/components/StatusIndicator/StatusIndicator';
import { dateFormat } from 'shared/helpers/parsers/date';
import { capitalize } from 'shared/helpers/parsers/text';

import dateAdapter from 'utils/date/dateAdapter';

import { HEDGES } from './hedgesConstants';

const itemsTemplate = [
  {
    label: HEDGES.TRUSTED_COMPANIES.STATUS,
    render: ({ status }) => <StatusIndicator status={status} />,
  },
  {
    label: HEDGES.TRUSTED_COMPANIES.COMPANY_NAME,
    render: ({ companyName }) => companyName,
  },
  {
    label: HEDGES.TRUSTED_COMPANIES.COMPANY_TYPE,
    render: ({ companyType }) => capitalize(companyType),
  },
  {
    label: HEDGES.TRUSTED_COMPANIES.LOT_PREFIX,
    render: ({ lotPrefix }) => lotPrefix,
  },
  {
    label: HEDGES.TRUSTED_COMPANIES.DATE_ADDED,
    render: ({ createdAt }) => dateAdapter(createdAt).format(dateFormat),
  },
  {
    label: HEDGES.TRUSTED_COMPANIES.ADDED_BY,
    render: ({ createdBy: { firstName, lastName } }) => `${firstName} ${lastName}`,
  },
];

const itemsTemplateMobile = [
  {
    label: HEDGES.TRUSTED_COMPANIES.STATUS,
    render: ({ status }) => <StatusIndicator status={status} />,
  },
  {
    label: HEDGES.TRUSTED_COMPANIES.COMPANY_NAME,
    render: ({ companyName }) => companyName,
  },
];

const [, , ...itemsDetailsTemplate] = itemsTemplate;

export { itemsTemplate, itemsTemplateMobile, itemsDetailsTemplate };
